module.exports = {"542524100":"日土镇","542524200":"热帮乡","542524201":"日松乡","542524202":"东汝乡","542524203":"多玛乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/542524.json
// module id = 2772
// module chunks = 0